import { startOfDay } from '@/utils/calendar/date'
import { computed, ref } from 'vue'

function getToday(): Date {
  return startOfDay(new Date())
}

/**
 * Layout-only state for the calendar page (dates, sidebar width).
 * Data fetching lives in `useConnectedCalendars` / `useCalendarPage`.
 */
export function useCalendarPageState() {
  const selectedDate = ref<Date>(getToday())
  const miniMonthAnchor = ref<Date>(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
  const sidebarVisible = ref(true)
  /** Week band in mini-month only when main view is week (prototype); off by default. */
  const highlightSelectedWeek = ref(false)

  const miniMonthLabel = computed(() => {
    const d = miniMonthAnchor.value
    return new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' }).format(d)
  })

  const selectDate = (d: Date): void => {
    selectedDate.value = startOfDay(d)
    miniMonthAnchor.value = new Date(d.getFullYear(), d.getMonth(), 1)
  }

  const goToToday = (): void => {
    selectDate(getToday())
  }

  const miniMonthPrev = (): void => {
    const d = new Date(miniMonthAnchor.value)
    d.setMonth(d.getMonth() - 1, 1)
    miniMonthAnchor.value = d
  }

  const miniMonthNext = (): void => {
    const d = new Date(miniMonthAnchor.value)
    d.setMonth(d.getMonth() + 1, 1)
    miniMonthAnchor.value = d
  }

  const toggleSidebar = (): void => {
    sidebarVisible.value = !sidebarVisible.value
  }

  return {
    selectedDate,
    miniMonthAnchor,
    sidebarVisible,
    highlightSelectedWeek,
    miniMonthLabel,
    selectDate,
    goToToday,
    miniMonthPrev,
    miniMonthNext,
    toggleSidebar,
    getToday
  }
}
